import { GridApi } from 'ag-grid-community';

export const hasActiveColumnFilter = (api: GridApi): boolean => {
  return Object.keys(api.getFilterModel()).length > 0;
}

export const hasActiveQuickFilter = (api: GridApi): boolean => {
  return !!api.getQuickFilter();
}

/*
  * ag grid doesn't have a native cellId.
  * This function gives us a way to uniquely identify a cell
  * by combining rowId with ColId
 */
export const buildUniqueCellId = (nodeId: string = '', columnId: string = ''): string => {
  if (nodeId && columnId) {
    return `row-(${nodeId})_col-(${columnId})`;
  } else {
    return '';
  }
}
